import React, { useEffect, useState } from 'react';
import { Check } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const PlanChoiceCards = ({ currentTier, onChoose }) => {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/api/subscription/plans`).then((r) => r.json()).then((d) => setPlans(d.plans || [])).catch(() => setPlans([]));
  }, []);

  return (
    <div className="space-y-4">
      {plans.map((p) => (
        <Card key={p.id} className={`p-5 border-2 ${p.id === 'pro' ? 'border-primary bg-primary/5' : 'border-border'}`} data-testid={`upgrade-plan-${p.id}`}>
          <div className="flex items-baseline justify-between mb-3">
            <h3 className="text-lg font-bold text-foreground">{p.name}</h3>
            <p className="text-2xl font-bold text-foreground">${p.monthly_price}<span className="text-sm text-muted-foreground">/mo</span></p>
          </div>
          {p.setup_fee > 0 && <p className="text-xs text-primary font-medium mb-3">+ ${p.setup_fee} one-time setup fee</p>}
          <ul className="space-y-1.5 mb-4">
            {(p.features || []).map((f) => (
              <li key={f} className="flex items-center gap-2 text-sm text-muted-foreground"><Check className="w-4 h-4 text-green-500" />{f}</li>
            ))}
          </ul>
          <Button className="w-full bg-primary hover:bg-primary/90" onClick={() => onChoose(p.id)} disabled={currentTier === p.id} data-testid={`upgrade-choose-${p.id}`}>
            {currentTier === p.id ? 'Current Plan' : `Choose ${p.name}`}
          </Button>
        </Card>
      ))}
    </div>
  );
};
